import { createAction } from 'lib/store-utils';
import { SetReloadNotificationIdPayload } from './types';

export const BOX_ROSTER_PAST_RELOAD_NOTIFICATION_HIDE = createAction('Roster copy / reload notification / hide');
export const BOX_ROSTER_PAST_SET_RELOAD_NOTIFICATION_ID = createAction<SetReloadNotificationIdPayload>('Roster copy / set reload notification id');
